import React from 'react';

const Footer = () => (
  <footer className="site-footer">
    <p>© {new Date().getFullYear()} Job Aggregator. Built by BulSU Students.</p>
    <p>Romer Cholo Cruz • Allan Valenzuela • Hugh Ariff Aserit • Eisen Liam</p>
  </footer>
);

export default Footer;
